import {
  AU_KM, angleBetween, bodyInfo, heliocentricEcliptic, moonGeocentric, norm, osculatingOrbit, rotationState, sub, type BodyId,
} from "@solar/ephemeris";

export interface InfoData {
  lonDeg: number; distSunAU: number; distEarthAU: number; lightMinSun: number;
  periodDays: number | null; a: number | null; e: number | null;
  obliquityDeg: number | null; rotHours: number | null; retrograde: boolean; diameterKm: number; verified: boolean;
}

/** 全部由星历实时计算（不含未核对的“事实”）。直径来自 bodies.json，标注为未核对。 */
export function computeInfo(id: BodyId, date: Date): InfoData {
  const info = bodyInfo(id);
  const p = heliocentricEcliptic(id, date), earth = heliocentricEcliptic("earth", date);
  const distSun = norm(p);
  const distEarth = id === "moon" ? norm(moonGeocentric(date)) : norm(sub(p, earth));
  let period: number | null = null, a: number | null = null, e: number | null = null, obl: number | null = null;
  if (id !== "sun") {
    const o = osculatingOrbit(id, date, 8);
    period = o.elements.periodDays; a = o.elements.a; e = o.elements.e;
    const rs = rotationState(id, date);
    if (rs) obl = (angleBetween(rs.north, o.normal) * 180) / Math.PI;
  }
  let rotHours: number | null = null, retro = false;
  const rs = rotationState(id, date);
  if (rs) {
    // 自转周期：W 的变化率（取 ±0.01 天中心差分）
    const h = 0.01, t = date.getTime();
    const w1 = rotationState(id, new Date(Math.min(t + h * 86400000, Date.UTC(2100, 0, 1))))!.spinDeg;
    const w0 = rotationState(id, new Date(Math.max(t - h * 86400000, Date.UTC(1900, 0, 1))))!.spinDeg;
    let dw = w1 - w0; dw = ((dw + 540) % 360) - 180 + (Math.abs(dw) > 180 ? 0 : 0);
    // 差分过小（太阳）或跨周期的情况：用小步长，不做展开
    const rate = (((w1 - w0 + 540) % 360) - 180) / (2 * h); // 度/天
    if (Math.abs(rate) > 1e-6) { rotHours = (360 / Math.abs(rate)) * 24; retro = rate < 0; }
    void dw;
  }
  return {
    lonDeg: ((Math.atan2(p.y, p.x) * 180) / Math.PI + 360) % 360, distSunAU: distSun, distEarthAU: distEarth,
    lightMinSun: (distSun * AU_KM) / 299792.458 / 60,
    periodDays: period, a, e, obliquityDeg: obl, rotHours, retrograde: retro, diameterKm: info.radiusKm * 2, verified: info.verified,
  };
}
